<template>
  <div class="content-wraper item-overview-single-item">
    <div class="container">
      <div>
        <h2>Producten</h2>
        <p>
          Selecteer hieronder het product of de producten die je wilt ontlenen.
          Op de detailpagina kun je vervolgens de beschikbaarheid nagaan en het
          product toevoegen aan je winkelwagen.
        </p>
      </div>
      <div class="row">
        <div class="col-lg-6" v-if="search">
          Je hebt gezocht op: {{ search }}
        </div>
        <div class="col-lg-6" v-if="search">
          <button class="btn btn-secondary" @click="clearSearch()">
            Op alle producten zoeken
          </button>
        </div>
        <div class="col-lg-12">
          <div class="row shop-top-bar mt-30">
            <!-- <div class="product-view-mode">
                            <ul role="tablist" class="nav shop-item-filter-list">
                                <li role="presentation" class="active"><a href="#grid" aria-controls="grid" role="tab" data-toggle="tab" class="active show" aria-selected="true"><i class="fa fa-th"></i></a></li>
                                <li role="presentation"><a href="#list" aria-controls="list" role="tab" data-toggle="tab"><i class="fa fa-th-list"></i></a></li>
                            </ul>
                        </div> -->
            <div class="col-lg-3 toolbar-amount">
              <span
                >Product
                <strong>{{ itemPageCounts.currentPageItemStartCount }}</strong>
                -
                <strong>{{ itemPageCounts.currentPageItemEndCount }}</strong>
                van de <strong>{{ items.Total }}</strong> product(en)</span
              >
            </div>
            <!-- <div class="category-select" style="display: flex">
                            <p style="margin: 12px 10px 0 0;">Categorie:</p>
                            <select class="nice-select" style="width: 225px;" @change="getItemsForCategory(selectedCategory)" v-model="selectedCategory">
                                <option value="All">-</option>
                                <option v-for="category in categories" :key="category.CategoryID" :value="category.CategoryID" >{{ category.Description }}</option>
                            </select>
                        </div> -->
            <!-- <div class="col-lg-6"> -->
            <treeselect
              :options="categories"
              :multiple="false"
              class="col mb-1"
              placeholder="Selecteer een categorie"
              v-model="selectedCategory"
              @input="getItemsForCategory(selectedCategory)"
            />
            <!-- </div> -->
            <div class="product-select-box col-lg-3">
              <div class="product-show">
                <p>Producten per pagina:</p>
                <!-- <div class="nice-select" tabindex="0" >
                                    <span class="current" v-model="">{{ items.Size }}</span>
                                    <ul class="list">
                                        <li data-value="2" class="option">15</li>
                                        <li data-value="3" class="option">30</li>
                                        <li data-value="4" class="option">45</li>
                                    </ul>
                                </div> -->
                <select
                  v-model="itemPageCounts.itemsPerPage"
                  number
                  style="border-radius: 5px;"
                >
                  <option :value="4">4</option>
                  <option :value="8">8</option>
                  <option :value="16">16</option>
                  <option :value="20">20</option>
                </select>
              </div>
            </div>
          </div>
          <div class="shop-products-wrapper">
            <div class="tab-content">
              <div id="grid" class="tab-pane fade active show" role="tabpanel">
                <div class="">
                  <div class="text-center" v-if="!itemsLoaded">
                    <div class="loading-animation">
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                  <div class="row">
                    <Item
                      v-for="item in items.Collection"
                      :key="item.ID"
                      :ID="item.ID"
                      :description="item.Description"
                      :brand="item.Brand"
                      :itemType="item.ItemType"
                      :imageUrl="item.ImageUrl"
                      :warehouseID="item.WarehouseID"
                      :items="item.Items"
                    >
                    </Item>
                  </div>
                </div>
              </div>
              <!-- paginatoin-area start -->
              <div class="paginatoin-area">
                <div class="row">
                  <div class="col-lg-6 col-md-6">
                    <p>
                      Artikel
                      <strong>{{
                        itemPageCounts.currentPageItemStartCount
                      }}</strong>
                      -
                      <strong>{{
                        itemPageCounts.currentPageItemEndCount
                      }}</strong>
                      van de <strong>{{ items.Total }}</strong> artikel(en)
                    </p>
                  </div>
                  <!-- <pagination
                                    :index="itemPageCounts.currentPage"
                                    :total="items.Total"
                                    :size="itemPageCounts.itemsPerPage"
                                    ></pagination> -->
                  <div class="col-lg-6 col-md-6">
                    <b-pagination
                      align="right"
                      size="md"
                      :total-rows="items.Total"
                      v-model="itemPageCounts.currentPage"
                      :per-page="itemPageCounts.itemsPerPage"
                    ></b-pagination>
                  </div>
                </div>
              </div>
              <!-- paginatoin-area end -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Item from './Item'
import swal from 'sweetalert'
// import Pagination from '../Global/Pagination'
import ItemService from '@/services/ItemService.js'
import CategoryService from '@/services/CategoryService.js'
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { BPagination } from 'bootstrap-vue'

export default {
    data () {
        return {
            items: [],
            itemsLoaded: false,
            itemPageCounts: {
                itemsPerPage: 16,
                currentPage: 1,
                currentPageItemStartCount: 0,
                currentPageItemEndCount: 0
            },
            itemCounts: [],
            selectedCategory: null,
            categories: [],
            search: null
        }
    },
    components: {
        Item,
        Treeselect,
        pagination: BPagination
    // Pagination
    },
    methods: {
        // async loadItems (search = null, size = null, index = null) {
        //     this.items = await ItemService.getItems(search, size, index)
        //     this.itemsLoaded = true
        //     this.getPageItemCounts()
        // },
        async getPageItemCounts () {
            this.itemPageCounts.currentPageItemStartCount =
                this.items.Size * this.items.Index + 1 - this.items.Size
            this.itemPageCounts.currentPage = this.items.Index
            this.itemPageCounts.currentPageItemEndCount =
                this.items.Size * this.items.Index

            if (this.items.Collection.length < this.items.Size) {
                this.itemPageCounts.currentPageItemEndCount = this.items.Total
            }
        },
        async getItems () {
            this.items = []
            this.itemsLoaded = false
            try {
                this.items = await ItemService.getItems(
                    this.itemPageCounts.currentPage,
                    this.itemPageCounts.itemsPerPage,
                    this.search
                )
                this.itemsLoaded = true
                this.getPageItemCounts()
            } catch (error) {
                swal(
                    '',
                    'De producten konden niet geladen worden. Probeer het later opnieuw.',
                    'warning'
                )
            }
        },
        async getItemsForCategory (categoryID) {
            this.search = null
            this.items = await ItemService.getItems(
                this.itemPageCounts.currentPage,
                this.itemPageCounts.itemsPerPage,
                null,
                categoryID
            )
            this.getPageItemCounts()
        },
        async getCategories () {
            this.categories = await CategoryService.getCategories()
            this.$store.dispatch('setCategories', this.categories)
        },
        clearSearch () {
            this.$router.push({ name: 'products' })
        },
        startup () {
            this.getCategories()
            if (this.$route.query.q) {
                this.search = this.$route.query.q
                this.getItems()
            } else if (this.$route.params.categoryID) {
                this.getItemsForCategory(this.$route.params.categoryID)
                this.selectedCategory = this.$route.params.categoryID
            } else {
                this.getItems()
            }
        }
    },
    watch: {
        '$route.query.q': function (newVal, oldVal) {
            this.search = newVal
            this.getItems()
        },
        '$store.getters.warehouse': function (newVal, oldVal) {
            this.getItems()
        },
        'itemPageCounts.currentPage': function (currentPage, previousPage) {
            this.getItems()
        },
        'itemPageCounts.itemsPerPage': function (newPerPage, oldPerPage) {
            this.getItems()
        }
    },
    created () {
        this.startup()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Products/Index.vue